define.alias("shared/utils/object-methods/object-snake-to-camel", "media/utils/object-methods/object-snake-to-camel");